import React from "react";
import type { IJadwalChangesInfo } from "../hooks/use-jadwal-changes";
import {
  Wrapper,
  Heading,
  ScheduleContainer,
  Schedule,
  ScheduleOldTiming,
  ScheduleNewTiming,
  Footer,
  Description
} from "./jadwal-changes-info.styles";

interface Props {
  data: IJadwalChangesInfo;
  timezone?: string;
}

const JadwalChangesInfo: React.FC<Props> = ({
  data: { heading, schedule, footer, description },
  timezone
}) => {
  return (
    <div>
      <Wrapper>
        <div>
          <Heading>{heading}</Heading>
          <Description>{description}</Description>
        </div>
        <ScheduleContainer>
          {schedule.map(
            ({ old_start_time, old_end_time, start_time, end_time }, i) => (
              <Schedule key={i}>
                <ScheduleOldTiming>
                  {old_start_time} - {old_end_time}
                </ScheduleOldTiming>
                <ScheduleNewTiming>
                  <div>
                    {start_time} - {end_time}
                  </div>
                  <div>{timezone}</div>
                </ScheduleNewTiming>
              </Schedule>
            )
          )}
        </ScheduleContainer>
      </Wrapper>
      <Footer>{footer}</Footer>
    </div>
  );
};

export default JadwalChangesInfo;
